export const SITE_URL = 'https://usfanssheet.guru';
export const SITE_NAME = 'USFansSheet';
export const SITE_LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';